<template>
  <div>
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">{{res_newsDetail.title}}</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <div class="d-flex justify-center mx-2 mt-3 w-100" fluid>
      <v-card class="px-2 w-50">
        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate
          ></v-progress-linear>
        </template>

        <v-img height="250" :src="res_newsDetail.banner_image_url"></v-img>

        <v-card-title>{{ res_newsDetail.title }}</v-card-title>

        <v-card-text>
          <div v-html="res_newsDetail.content"></div>
        </v-card-text>
        <span class="text-grey-sm"
          >Created By: {{ res_newsDetail.author_name }}</span
        >
      </v-card>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const news = createNamespacedHelpers("news");

export default {
  name: "News",
  computed: {
    ...news.mapState(["res_newsDetail", "idNews"])
  },
  mounted() {
    this.$store.commit("news/SET_IDNEWS", this.idNews);
    this.$store.dispatch("news/getNewsDetail");
  },
  data() {
    return {};
  },
  components: {},
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    closeSuccessNavigate() {
      this.$router.go(-1);
    }
  }
};
</script>
